import { h, Component, Fragment } from 'preact';
import noaaLogo from './../../assets/gallery-icon.svg';
import galleriesService from '../services/galleries.service';

export default class GalleriesComponent extends Component {
    constructor() {
        super();

        this.state = {
            currentNode: galleriesService.getCurrentNode(),
            currentPathArray: galleriesService.getCurrentPathArray(),
            breadcrumbs: null,
            galleries: null
        };
    }

    componentDidMount() {
        this.updateGalleries();
    }

    handleGalleryClick(gallery) {
        if (gallery.type === 'directory') {
            const galleryKey = Object.keys(this.state.currentNode.children).filter(c => this.state.currentNode.children[c].name === gallery.name);
            this.state.currentPathArray.push(galleryKey);
            galleriesService.setCurrentPath(this.state.currentPathArray);
            this.updateGalleries();
        } else if (gallery.type === 'file') {
            galleriesService.openPhotoViewer(gallery);
        }
    }

    handleBreadcrumbClick(pathArray) {
        this.state.currentPathArray = pathArray;
        galleriesService.setCurrentPath(this.state.currentPathArray);
        this.updateGalleries();
    }

    updateGalleries() {
        const currentNode = galleriesService.getCurrentNode();
        const currentPathArray = galleriesService.getCurrentPathArray();

        // Track breadcrumbs path array
        let tempNode = galleriesService.getRootNode();
        const tempPathArray = [];

        const crumbs = [{ name: 'Photos', index: [] }];
        currentPathArray.forEach(crumb => {
            tempNode = tempNode.children[crumb];
            tempPathArray.push(crumb);
            crumbs.push({ name: tempNode.name, index: tempPathArray.map(c => c) });
        });

        this.setState({
            currentNode,
            currentPathArray,
            galleries: currentNode.children.map(gallery => (
                <div
                    class="card"
                    onClick={() => this.handleGalleryClick(gallery)}
                >
                    <div class="card__image">
                        <img width="100" height="100" src={gallery.type === 'file' ? gallery.thumb : noaaLogo} />
                    </div>
                    <h2 class="card__title">
                        {gallery.type === 'directory' ? gallery.name : ''}
                    </h2>
                </div>
            )),
            breadcrumbs: crumbs.map(c => (
                <span
                    className={c.name}
                    onMouseEnter={() => { document.getElementsByClassName(c.name)[0].style.cursor = 'pointer'; }}
                    onMouseLeave={() => { document.getElementsByClassName(c.name)[0].style.cursor = ''; }}
                    onClick={() => this.handleBreadcrumbClick(c.index)}>
                    { c.name + ' » '}
                </span>
            ))
        });
        this.forceUpdate();
    }

    render() {
        return (
            <Fragment>
                <galleries-container class="galleryContainer flex-container--row contain-width">
                    <div class="breadCrumbs">
                        {this.state.breadcrumbs}
                    </div>
                    {this.state.galleries}
                </galleries-container>
            </Fragment>
        );
    }
}
